(function () {
  var flickityOptions = {
    pageDots: false,
    freeScroll: true,
    wrapAround: true,
    contain: true,
    cellAlign: "left",
  };

  function findAll(root, selector) {
    var scope = root || document;
    var items = [];

    if (scope.matches && scope.matches(selector)) {
      items.push(scope);
    }

    scope.querySelectorAll(selector).forEach(function (item) {
      items.push(item);
    });

    return items;
  }

  function initReviewCarousels(root) {
    if (typeof Flickity === "undefined") return;

    findAll(root, ".custom-review").forEach(function (carousel) {
      var existingInstance = Flickity.data(carousel);

      if (existingInstance) {
        existingInstance.resize();
        carousel.dataset.reviewCarouselReady = "true";
        initReviewMobileDots(carousel, existingInstance);
        return;
      }

      if (!carousel.children.length) return;

      var instance = new Flickity(carousel, flickityOptions);
      carousel.dataset.reviewCarouselReady = "true";
      initReviewMobileDots(carousel, instance);
    });
  }

  function initReviewMobileDots(carousel, instance) {
    if (!carousel || !instance || !carousel.closest(".kates-inspiration-image-with-reviews")) return;

    var cards = Array.prototype.slice.call(carousel.querySelectorAll(".custom-review-flip-card"));
    if (cards.length < 2) return;

    var section = carousel.closest(".kates-inspiration-image-with-reviews");
    var dots = section.querySelector(".custom-review-mobile-dots");

    if (!dots) {
      dots = document.createElement("div");
      dots.className = "custom-review-mobile-dots";
      dots.setAttribute("aria-label", "Review pagination");
      carousel.insertAdjacentElement("afterend", dots);
    }

    if (dots.dataset.reviewDotsReady !== "true" || dots.children.length !== cards.length) {
      dots.innerHTML = "";
      cards.forEach(function (_, index) {
        var dot = document.createElement("button");
        dot.type = "button";
        dot.className = "custom-review-mobile-dot";
        dot.setAttribute("aria-label", "Go to review " + (index + 1));
        dot.addEventListener("click", function () {
          instance.select(index);
        });
        dots.appendChild(dot);
      });
      dots.dataset.reviewDotsReady = "true";
    }

    function updateDots() {
      var selected = instance.selectedIndex || 0;
      Array.prototype.slice.call(dots.children).forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === selected);
      });
    }

    if (carousel.dataset.reviewDotsBound !== "true") {
      instance.on("select", updateDots);
      carousel.dataset.reviewDotsBound = "true";
    }

    updateDots();
  }

  function initReviewFlipCards(root) {
    var canHover = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    findAll(root, ".kates-inspiration-image-with-reviews [data-review-flip-card]").forEach(function (card) {
      if (card.dataset.reviewFlipReady === "true") return;

      if (canHover) {
        card.addEventListener("mouseenter", function () {
          card.classList.add("is-flipped");
        });

        card.addEventListener("mouseleave", function () {
          card.classList.remove("is-flipped");
        });
      }

      card.addEventListener("click", function (event) {
        if (event.target.closest("a")) return;
        if (canHover) return;
        card.classList.toggle("is-flipped");
      });

      card.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        card.classList.toggle("is-flipped");
      });

      card.dataset.reviewFlipReady = "true";
    });
  }

  function initImageWithReviews(root) {
    initReviewCarousels(root);
    initReviewFlipCards(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initImageWithReviews(document);
    });
  } else {
    initImageWithReviews(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    window.setTimeout(function () {
      initImageWithReviews(event.target);
    }, 0);
  });

  document.addEventListener("shopify:block:select", function (event) {
    var carousel = event.target && event.target.closest && event.target.closest(".custom-review");
    var instance = carousel && typeof Flickity !== "undefined" ? Flickity.data(carousel) : null;

    if (instance) {
      instance.resize();
    }
  });
})();
